import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { StatusBadge } from "./common";
import { BUD } from "../data/content";

// Single approved Bud card — used on the homepage Active Development section and
// the /portfolio Active development section so the surfaces cannot drift.
// Launched WarRoom Labs product, live at bud.titanhavengroup.com — research and
// education tooling, never presented as investment advice.
export const BudCard = () => (
    <Link
        to="/portfolio/bud"
        data-testid="bud-card"
        className="group block bg-thg-surface border border-thg-border hover:bg-thg-surfacehover hover:border-[#404040] transition-colors duration-300"
    >
        <div className="relative overflow-hidden border-b border-thg-border">
            <img
                src="/assets/products/bud-open-desk.jpg"
                alt="Bud's Market Intelligence Desk — historical interface capture; not the current live UI. The current product is the Bud Basket v2.6 at bud.titanhavengroup.com"
                className="w-full aspect-[16/9] object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                loading="lazy"
            />
            <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_70px_rgba(0,0,0,0.5)]" aria-hidden="true" />
        </div>
        <div className="p-8 md:p-10">
            <div className="flex flex-wrap items-center gap-3">
                <StatusBadge testId="bud-card-status">{BUD.status}</StatusBadge>
                <span className="text-xs tracking-[0.15em] uppercase text-thg-tertiary">WarRoom Labs</span>
            </div>
            <h3 className="mt-5 font-display font-medium text-white text-2xl md:text-3xl">{BUD.name}</h3>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary">
                An experimental WarRoom Labs market-intelligence desk — live at bud.titanhavengroup.com
                with live market data, the defined-cycle Bud Basket v2.6, and a graded public record of archived
                calls. Members can follow the desk. Research and education tooling, not investment advice.
            </p>
            <p className="mt-3 text-xs leading-relaxed text-thg-tertiary">
                Launched September 8, 2026 — the record is building in public.
            </p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm text-thg-secondary group-hover:text-white transition-colors duration-300">
                View project
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </span>
        </div>
    </Link>
);
